import { isDev } from "@/lib/chillnn/enviroment";

/**
 * 開発モードで使えるツールを提供する
 * @returns {boolean} isDev
 */
export function DevelopmentTools() {
	/**
	 * 開発モードでのみコンソールログを出力する
	 * @param message
	 */
	const consoleLogOnlyDevMode = (...message: unknown[]) => {
		if (isDev) {
			// eslint-disable-next-line no-console
			console.log(...message);
		}
	};

	/**
	 * 開発モードでのみコンソールエラーを出力する
	 * @param err
	 */
	const consoleErrorOnlyDevMode = (...err: unknown[]) => {
		if (isDev) {
			// eslint-disable-next-line no-console
			console.error(...err);
		}
	};

	return {
		isDev,
		consoleLogOnlyDevMode,
		consoleErrorOnlyDevMode,
	};
}
